export function buildDealerUsersListTableHeaders({ t, showImpersonateColumn = false }) {
  const headers = [
    {
      value: "id",
      text: t("page.users.id"),
      thClass: "w-24",
      tdClass: "max-w-[2rem] min-w-[5rem]",
      disabled: true,
    },
    {
      value: "user",
      text: t("page.users.user"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[10rem] min-w-[10rem]",
    },
    {
      value: "contacts",
      text: t("page.users.contacts"),
      thClass: "w-[10rem]",
      tdClass: "max-w-[12rem] min-w-[10rem]",
    },
    {
      value: "customer",
      text: t("page.users.customer"),
      thClass: "w-[10rem]",
      tdClass: "max-w-[12rem] min-w-[10rem]",
    },
    {
      value: "visit",
      text: t("page.users.visit"),
      thClass: "w-[8rem]",
      tdClass: "max-w-[10rem] min-w-[8rem]",
    },
    {
      value: "status",
      text: t("page.fleaMarket.status"),
      thClass: "w-[7rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
  ];

  if (showImpersonateColumn) {
    headers.push({
      value: "buttons",
      label: t("page.users.buttons"),
      thClass: "w-[4rem]",
      tdClass: "max-w-[4rem]",
      disabled: true,
    });
  }

  return headers;
}
